import { createFileRoute } from '@tanstack/react-router'
import { ToolPage } from '@/components/tool-page/tool-page'
import { toolHead } from '@/components/tool-page/tool-head'
import { DnsTool } from '@/components/tool-page/dns-tool'
import { TOOLS } from '@/lib/tool-content'

const content = TOOLS['txt-record-lookup']

export const Route = createFileRoute('/_site/tools/txt-record-lookup')({
  component: TxtRecordLookupPage,
  validateSearch: (search: Record<string, unknown>): { q?: string } => ({
    q: typeof search.q === 'string' && search.q ? search.q : undefined,
  }),
  head: () => toolHead(content),
})

function TxtRecordLookupPage() {
  const { q } = Route.useSearch()
  return (
    <ToolPage content={content}>
      <DnsTool content={content} fixedType="TXT" initialName={q ?? ''} autoRun={!!q} showTxtLinks />
    </ToolPage>
  )
}
